import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M3.33333 16.6667V2.5H2.5V17.5H18.3333V16.6667H3.33333Z",
      fill: "currentColor"
    }, null, -1),
    _createElementVNode("path", {
      d: "M12.5 14.1667V3.33333H11.6667V14.1667H12.5Z",
      fill: "currentColor"
    }, null, -1),
    _createElementVNode("path", {
      d: "M8.33333 14.1667V8.33333H7.5V14.1667H8.33333Z",
      fill: "currentColor"
    }, null, -1),
    _createElementVNode("path", {
      d: "M16.6667 14.1667V10H15.8333V14.1667H16.6667Z",
      fill: "currentColor"
    }, null, -1)
  ])))
}
export default { render: render }